import { Box, Flex, Modal, type ModalProps, Text, theme } from '@/components';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchUsersForm } from './SearchUsersForm';
import { SearchUsersTable } from './SearchUsersTable';

const InnerContent: FC = () => {
  const [userName, setUserName] = useState<string | null | undefined>('');
  const [organizationIds, setOrganizationIds] = useState<string[]>();
  const [pageNumber, setPageNumber] = useState(1);

  return (
    <Flex vertical justify="space-between">
      <Box flex={1} padding={32} paddingBottom={16}>
        <Flex vertical gap="middle">
          <SearchUsersForm
            onClear={() => {
              setUserName(undefined);
              setOrganizationIds(undefined);
              setPageNumber(1);
            }}
            onSubmit={(values) => {
              setUserName(values.userName);
              setOrganizationIds(
                values.organizationIds?.flatMap((id) => id.at(-1) ?? []),
              );
              setPageNumber(1);
            }}
          />
          <SearchUsersTable
            organizationIds={organizationIds}
            pageNumber={pageNumber}
            userName={userName}
            setPageNumber={setPageNumber}
          />
        </Flex>
      </Box>
    </Flex>
  );
};

type Props = {
  open: ModalProps['open'];
  onClose: ModalProps['onCancel'];
};

export const SearchUsersModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Modal
      centered
      destroyOnClose
      width={1000}
      styles={{
        content: {
          padding: 0,
          height: 600,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
        header: {
          paddingInline: 24,
          paddingTop: 16,
          marginBottom: 16,
        },
        footer: {
          padding: 16,
          paddingTop: 0,
          marginTop: 16,
        },
        body: {
          flex: 1,
          border: `1px solid ${token.colorBorderSecondary}`,
          borderLeft: 'none',
          borderRight: 'none',
        },
      }}
      title={<Text variant="h5" text={t('search-users-or-organizations')} />}
      open={open}
      onCancel={onClose}
      cancelText={t('close')}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <InnerContent />
    </Modal>
  );
};
